module.exports = __webpack_public_path__ + "static/media/esn.caa48deb.png";